import { EventInput } from '@fullcalendar/core';
import { Task, Timestamp, WeekDays } from '@griply/types';
import { getTasksCalendarEvents } from '@griply/utils';

import { mapCalendarEventToEventInput } from './map-calendar-event-to-event-input';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
  today: Timestamp;
  weekStartsOn: WeekDays;
  hideCompleted?: boolean;
};

export const getTasksEventsForDateRange = (
  tasks: Task[],
  options: Options,
): EventInput[] => {
  const tasksById = new Map(tasks.map((task) => [task.id, task]));

  return getTasksCalendarEvents(tasks, options).map((event) =>
    mapCalendarEventToEventInput(
      event,
      event.taskId ? tasksById.get(event.taskId) : undefined,
      options.weekStartsOn,
    ),
  );
};
